import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import uniqueId from 'lodash/uniqueId';

import Form from '../../../../components/Form';
import Input from '../../../../components/Input';
import Label from '../../../../components/Label';
import Checkbox from '../../../../components/Checkbox';
import Dropdown from '../../../../components/Dropdown';
import ErrorLabel from '../components/ErrorLabel';
import messages from './messages';
import basicInfoMessages from '../messages';

import '../styles.css';

const INPUTS = [
  'numberOfMacsInComputerCenters',
  'numberOfPCsInComputerCenters',
  'numberOfMacsInDepartmentLabs',
  'numberOfPCsInDepartmentLabs',
  'numberOfMacsInLibraries',
  'numberOfPCsInLibraries',
  'numberOfMacsInStudentCenters',
  'numberOfPCsInStudentCenters',
  'numberOfMacsInResidences',
  'numberOfPCsInResidences',
  'numberOfMacsInOther',
  'numberOfPCsInOther',
];
const CHECKS = [
  'internetAccessInLibrary',
  'wirelessInternetAccess',
  'internetAccessOnCentralCampus',
  'internetAccessInResidenceHalls',
  'computerRequired',
];

const COMPUTER_TYPE = [
  { key: 'NO_DATA',
    value: '0',
    text: 'No data',
  },
  { key: 'PC',
    value: '1',
    text: 'PC',
  },
  { key: 'MACINTOSH',
    value: '2',
    text: 'Macintosh(tm)',
  },
];

const ComputingResources = ({ onChange, initialValue }) => {
  const computerRequiredReasonId = uniqueId('computer-required-reason');
  const preferredComputerTypeId = uniqueId('preferred-computer-type');

  return (
    <React.Fragment>
      {
        INPUTS.map((key) => (
          <div styleName="field" key={key}>
            <Label styleName="menu-field-label" as="label" htmlFor={key}>
              <FormattedMessage {...messages[key]} />
            </Label>
            <Input
              fluid
              type="number"
              min="0"
              id={key}
              value={initialValue[key].value}
              onChange={(e, { value }) => {
                onChange(e, {
                  [key]: { ...initialValue[key], value },
                });
              }}
            />
            {initialValue[key].showError && <ErrorLabel error={{ ...basicInfoMessages.invalidError }} />}
          </div>
        ))
      }
      {
        CHECKS.map((key) => (
          <Form.Field styleName="field" key={key}>
            <Checkbox
              label={{
                htmlFor: key,
                children: <FormattedMessage {...messages[key]} />,
              }}
              checked={!!Number(initialValue[key].value)}
              onChange={(e) => {
                // instead of boolean value we put '0' or '1'
                const value = e.target.checked === true ? '1' : '0';
                onChange(e, {
                  [key]: { ...initialValue[key], value },
                });
              }}
            />
          </Form.Field>
        ))
      }
      <div styleName="field">
        <Label styleName="menu-field-label" as="label" htmlFor={computerRequiredReasonId}>
          <FormattedMessage {...messages.computerRequiredReason} />
        </Label>
        <Input
          data-cy="Premium-Hem-Computer-Required-Reason-Input"
          fluid
          id={computerRequiredReasonId}
          value={initialValue.computerRequiredReason.value}
          onChange={(e, { value }) => {
            onChange(e, {
              computerRequiredReason: { ...initialValue.computerRequiredReason, value },
            });
          }}
        />
      </div>
      <Form.Field styleName="field">
        <Checkbox
          label={{
            htmlFor: 'computerPurchaseOffered',
            children: <FormattedMessage {...messages.computerPurchaseOffered} />,
          }}
          checked={!!Number(initialValue.computerPurchaseOffered.value)}
          onChange={(e) => {
            // instead of boolean value we put '0' or '1'
            const value = e.target.checked === true ? '1' : '0';
            onChange(e, {
              computerPurchaseOffered: { ...initialValue.computerPurchaseOffered, value },
            });
          }}
        />
      </Form.Field>
      <div styleName="field">
        <Label styleName="menu-field-label" as="label" htmlFor={preferredComputerTypeId}>
          <FormattedMessage {...messages.preferredComputerType} />
        </Label>
        <Dropdown
          data-cy="Premium-Hem-Preferred-Computer-Type-Dropdown"
          name="preferredComputerType"
          selection
          id={preferredComputerTypeId}
          value={initialValue.preferredComputerType.value}
          options={COMPUTER_TYPE}
          onChange={(e, { value }) => {
            onChange(e, {
              preferredComputerType: { ...initialValue.preferredComputerType, value },
            });
          }}
        />
      </div>
    </React.Fragment>
  );
};

ComputingResources.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
};

export default ComputingResources;
